





















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/clients';
import * as unidadeService from '@/services/client-unit';
import ClientModel from '@/models/client-model';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ClientUnitModel from '../../models/client-unit-model';
import ClientUnitForm from '@/components/client-units/client-unit-form.vue';
import { IUnitClient } from '../../interfaces/client';
import { dateFormat } from '../../helpers/dateFormat';
import { checkUserPermissions } from '../../services/auth';
import { PERMISSIONS_KEYS } from '../../settings/consts/permissions';

@Component({
  components: {
    PermissionAuth,
    ClientUnitForm,
  },
})
export default class ClientForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;

  public form: any = {
    valid: false,
    rules: {
      cnpj: [(v) => !!v || 'Digite o CNPJ'],
      name: [(v) => !!v || 'Digite o nome'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: ClientModel = new ClientModel();
  public healthInsurance: any[] = [];
  public products: any[] = [];

  private formUnidadeOpen: boolean = false;
  private unidadeEdit: ClientUnitModel = null;

  public unidadeHeaders: any = [
    { text: 'Unidade', value: 'nome', sortable: true },
    { text: 'Ativa', value: 'ativo', sortable: true },
    { text: 'Ações', value: 'actions', align: 'center', sortable: false },
  ];

  private isUnidadeSomenteLeitura() {
    return checkUserPermissions([PERMISSIONS_KEYS.CLIENT_UNIT_VIEW]) && 
          !checkUserPermissions([PERMISSIONS_KEYS.CLIENT_UNIT_EDIT]) &&
          !checkUserPermissions([PERMISSIONS_KEYS.CLIENT_UNIT_INSERT]) &&
          !checkUserPermissions([PERMISSIONS_KEYS.CLIENT_UNIT_DELETE]);
  }

  public get dataContrato(): string {
    return !!this.item.vencimentoContrato
      ? dateFormat(this.item.vencimentoContrato.toString(), 'BR')
      : null;
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new ClientModel(val);
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');
    const item = this.item.toJson();

    if (!this.item.id) {
      service.saveClient(item).subscribe(
        (data) => {
          this.loader.stop();
          this.$emit('save');
          this.$refs.form.resetValidation();
        },
        () => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao criar o cliente', 'error');
        },
      );
    } else {
      service.activateClient(item.id, item.ativo).subscribe(
        (data) => {
          this.loader.stop();
          this.$emit('save');
          this.$refs.form.resetValidation();
        },
        () => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao atualizar o cliente', 'error');
        },
      );
    }
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  public onEditUnidade(item: ClientUnitModel): void {
    this.loader.start('Carregando item...');
    unidadeService.getClientUnit(item.id).subscribe(
      (data) => {
        this.unidadeEdit = new ClientUnitModel(data);
        this.formUnidadeOpen = true;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar a Unidade', 'error');
      },
    );
  }

  public saveUnidade(item: IUnitClient): void {
    this.closeUnidadeForm();
  }

  public closeUnidadeForm(): void {
    this.formUnidadeOpen = false;
  }
}
